import { render, staticRenderFns } from "./CheckoutAddress.vue?vue&type=template&id=3b8ce014&scoped=true"
import script from "./CheckoutAddress.vue?vue&type=script&lang=js"
export * from "./CheckoutAddress.vue?vue&type=script&lang=js"
import style0 from "./CheckoutAddress.vue?vue&type=style&index=0&id=3b8ce014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8ce014",
  null
  
)

export default component.exports